import { render, staticRenderFns } from "./OrderPackagePlanProduct.vue?vue&type=template&id=0f427819&scoped=true&"
import script from "./OrderPackagePlanProduct.vue?vue&type=script&lang=js&"
export * from "./OrderPackagePlanProduct.vue?vue&type=script&lang=js&"
import style0 from "./OrderPackagePlanProduct.vue?vue&type=style&index=0&id=0f427819&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f427819",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VCol,VDialog,VRow,VSimpleTable})
